import one from "../assets/one.png"
import two from "../assets/two.png"
import three from "../assets/three.png"
import four from "../assets/four.png"
import f from "../assets/f.png"
import insta from "../assets/insta.png"
import store from "../assets/store.png"
import twitter from "../assets/twitter.png"
import fb from "../assets/fb.png"
import feed from "../assets/feed.png"
import p1 from "../assets/p1.png"
import p2 from "../assets/p2.png"
import p3 from "../assets/p3.png"
import p4 from "../assets/p4.png"
import p5 from "../assets/p5.png"
import del from "../assets/del.png"
import check from "../assets/check.png"
import arrow from "../assets/Vector.png"
import like from "../assets/blike.png"
import message from "../assets/arrowup.png"
import arrow2 from "../assets/Vector (3).png"
import hide from "../assets/Hide.png"


export const Social = [
    {
        "img": one,
        "name": "Adam Person"

    },
    {
        "img": two,
        "name": "Adam Person"

    },
    {
        "img": three,
        "name": "Adam Person"

    },
    {
        "img": four,
        "name": "Adam Person"

    },
]
export const Sosialarray = [
    {
        "img": f,
        "name": "Facebook"
    },
    {
        "img": insta,
        "name": "Instagram"
    },
    {
        "img": store,
        "name": "Google my Business"
    },
    {
        "img": twitter,
        "name": "Twitter"
    },
]
export const data = [
    {
        "img": feed,
    },
    {
        "img": p1,
    },
    {
        "img": p2,
    },
    {
        "img": p3,
    },
    {
        "img": p4,
    },
    {
        "img": p5,
    },
]
export const socialdata = [
    {
        "image": del
    },
    {
        "image": del
    },
    {
        "image": del
    },
    {
        "image": del
    },
    {
        "image": del
    },
    {
        "image": del
    },
    {
        "image": del
    },
    {
        "image": del
    },
    ,
    {
        "image": del
    },
]
export const Payment = [
    {
        "img": check,
        "title": "Unlimited scheduling & draft"
    },
    {
        "img": check,
        "title": "Bulk scheduling"
    },
    {
        "img": check,
        "title": "Unlimited scheduling & draft"
    },
    {
        "img": check,
        "title": "Link in bio (unbranded)"
    },
    {
        "img": check,
        "title": "Automatic RSS posting"
    },
]
export const Payments = [
    {
        "img": check,
        "title": "Watermark photos"
    },
    {
        "img": check,
        "title": "Signatures"
    },
    {
        "img": check,
        "title": "Schedule follow-up comments"
    },
    {
        "img": check,
        "title": "Create aditional workspaces"
    },
    {
        "img": check,
        "title": "Eternal post history"
    },
]
export const Payment1 = [
    {
        "img": check,
        "title": "View insights"
    },
    {
        "img": check,
        "title": "Find best times to post"
    },
    {
        "img": check,
        "title": "Automatic analytics reports"
    },
    {
        "img": check,
        "title": "Hashtag suggestions"
    },
    {
        "img": check,
        "title": "Content recommendation"
    },
]
export const Payment2 = [
    {
        "img": check,
        "title": "Watermark Videos"
    },
    {
        "img": check,
        "title": "Design videos (VistaCreate Pro)"
    },
    {
        "img": check,
        "title": "Automatically recycle posts"
    },
    {
        "img": check,
        "title": "Schedule recurring posts"
    },
    {
        "img": check,
        "title": "Spintax support"
    },
]
export const socialicons = [
    {
        "img": insta,
        "text": "Instagram"
    },
    {
        "img": twitter,
        "text": "Twitter"
    },
    {
        "img": fb,
        "text": "Facebook"
    },
]
export const analyticarray = [
    {
        "img": like,
        "text1": "Avg Likes",
        "img2": arrow,
        "text2": "49%"
    },
    {
        "img": hide,
        "text1": "Avg Views",
        "img2": arrow,
        "text2": "49%"
    },
    {
        "img": message,
        "text1": "Avg Comments",
        "img2": arrow2,
        "text2": "49%"
    },
]
export const BannerData = [
    {
        "heading": "Top Banner",
        "name": "Adam Person",
        "mail": "@AdamPerson",
        "text": "Lorem ipsum dolor sit amet consecte tur. Malesuada sagittis ac ipsum eu morbi ut aliquet."
    }, {
        "heading": "Middle Banner",
        "name": "Adam Person",
        "mail": "@AdamPerson",
        "text": "Lorem ipsum dolor sit amet consecte tur. Malesuada sagittis ac ipsum eu morbi ut aliquet."
    }, {
        "heading": "Bottom Banner",
        "name": "Adam Person",
        "mail": "@AdamPerson",
        "text": "Lorem ipsum dolor sit amet consecte tur. Malesuada sagittis ac ipsum eu morbi ut aliquet."
    },
]
export const HeaderData = [
    {
        "date": "04 DEC",
        "name": "Adam Person",
        "text": "Lorem ipsum dolor sit amet consectetur. Malesuada sagittis ac ipsum eu morbi ut aliquet. @samuel consecte."
    },
    {
        "name": "Adam Person",
        "text": "Lorem ipsum dolor sit amet consectetur. Malesuada sagittis ac ipsum eu morbi ut aliquet. @samuel consecte."
    },
    {
        "name": "Adam Person",
        "text": "Lorem ipsum dolor sit amet consectetur. Malesuada sagittis ac ipsum eu morbi ut aliquet. @samuel consecte."
    },

]